// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_lt-0";
export var fileCarousel = "_lt-2";
export var removeFileButton = "_lt-1";